import React from 'react'
import { getContentfulImageURL } from '../../../../lib/helpers';
import CategoryTag from '../../General/CategoryTag';
import { Link } from 'gatsby';


const ArticlesLandingSection = ({images, isLinkOut, data}) => {
    if (!images) return null;

    return (
        <div className='article-landing'>
            {
                isLinkOut ? 
                    <div className="link-out-cta">
                        <h3 className='graphik cta-heading'>{data?.v2ArticlesHomepageLinkHeading?.v2ArticlesHomepageLinkHeading}</h3>
                        <p className='cta-copy'>{data?.v2ArticlesHomepageLinkCopy?.v2ArticlesHomepageLinkCopy}</p>
                        <Link to="/articles/">
                            <CategoryTag>Explore</CategoryTag>
                        </Link>
                    </div>
                :
                    <div className="link-out-cta">
                        <h3 className='landing-heading'>Articles</h3>
                        <p className='article-copy'>
                            {data?.allContentfulSiteGlobalData?.edges[0]?.node.v2ArticlesIntroCopy?.v2ArticlesIntroCopy}
                        </p>
                    </div>
            }
            
            {images.map((image, idx) => {
                return (
                    <span key={`arls-${idx}`} className={`img-wrap img-wrap-${idx}`}>
                        <img className={`img-${idx}`}src={getContentfulImageURL(image.file.url, 600, 85)} alt=""/>
                    </span>
                )
            })}
            <style jsx>{`
                .article-landing {
                    height: 550px;
                    position: relative;
                    overflow: hidden;
                    contain: strict;
                }

                .landing-heading {
                    font-size: 70px;
                    font-weight: 400;
                    margin-bottom: 15px;

                    font-family: 'Elizeth';
                    font-weight: 900;
                }

                .link-out-cta {
                    position: absolute;
                    width: 750px;
                    z-index: 1;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);

                    text-align: center;
                }

                .cta-heading {
                    font-weight: 400;
                    font-size: 50px;
                    margin-bottom: 12px;
                }
                .cta-copy {
                    font-size: 16px;
                    margin-bottom: 20px;
                }

                .article-copy {
                    font-size: 20px;
                    width: 100%;
                    text-align: center;
                    margin: 0 auto;
                }

                .link-out-cta :global(.category-tag) {
                    transition: all 0.2s ease-in-out;
                }

                .link-out-cta :global(.category-tag:hover) {
                    background: rgba(130,130,130,.75);
                    color: white;
                    
                    
                }

                .article-landing :global(img) {
                    animation: bobbing 40s infinite alternate;
                }

                .img-wrap {
                    position: absolute;
                }

                @keyframes bobbing {
                    0% {
                      transform: translate(0, 0);
                    }
                    25% {
                      transform: translate(10px, 15px);
                    }
                    50% {
                      transform: translate(15px, -10px);
                    }
                    75% {
                      transform: translate(-10px, -15px);
                    }
                    100% {
                      transform: translate(-15px, 10px);
                    }
                  }
                  
                .img-wrap-0 {
                    left: 0;
                    top: 30%;
                    transform: translateX(-50%);
                }

                .article-landing .img-0 {
                    animation-delay: -20s;
                }

                .img-wrap-1 {
                    left: 18%;
                    top: -35%;
                }

                .article-landing .img-1  {
                    animation-delay: -33.3s;
                }
                
                .img-wrap-2 {
                    left: 50%;
                    bottom: -45%;
                }

                .article-landing .img-2  {
                    animation-delay: -44.4s;

                }

                .img-wrap-3 {
                    left: 60%;
                    top: 0;
                    transform: translateY(-50%);
                }


                .article-landing .img-3 {
                    animation-delay: -55.5s;
                }


                .img-wrap-4 {
                    right: 0;
                    top: 10%;
                    transform: translateX(60%);
                }

                .article-landing .img-4  {
                    animation-delay: -66.6s;
                }


                img {
                    width: 300px;
                    border-radius: 15px;
                }

                @media (max-width: 769px), (pointer: coarse) {

                    .landing-heading {
                        font-size: 56px;
                    }

                    .link-out-cta {
                        width: 100%;
                        padding: 0 20px;
                    }
                    .cta-heading {
                        font-size: 46px;
                    }

                    .cta-copy, .article-copy {
                        font-size: 19px;
                    }
                    img {
                        width: 150px;
                    }
                    .img-wrap-0 {
                        left: 0;
                        top: 70%;
                        transform: translateX(-50%);
                    }
                    .img-wrap-1 {
                        left: 10%;
                        top: -10%;
                        transform: translateX(-50%);
                    }
                }



            `}</style>
        </div>
    )
}

export default ArticlesLandingSection
